export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: "official-entrance",
    name: "官方入口",
    description: "caoliu 官方最新入口地址、备用域名及镜像站点汇总，确保您随时访问",
    icon: "ri-link-m",
    articleCount: 8,
  },
  {
    slug: "usage-guide",
    name: "使用指南",
    description: "从注册到高级功能，手把手教你玩转 caoliu 社区的完整教程",
    icon: "ri-book-open-line",
    articleCount: 12,
  },
  {
    slug: "safe-access",
    name: "安全访问",
    description: "翻墙工具配置、VPN 推荐、DNS 优化等安全访问 caoliu 的实用技巧",
    icon: "ri-shield-check-line",
    articleCount: 6,
  },
  {
    slug: "community-guide",
    name: "社区指南",
    description: "caoliu 社区版规、等级体系、积分规则及资源发布规范全解析",
    icon: "ri-group-line",
    articleCount: 10,
  },
  {
    slug: "mirror-sites",
    name: "镜像站点",
    description: "caoliu 全球镜像站点分布、测速对比及自动切换方案推荐",
    icon: "ri-global-line",
    articleCount: 5,
  },
  {
    slug: "faq-help",
    name: "常见问题",
    description: "caoliu 使用过程中的常见问题解答、故障排除与客服联系渠道",
    icon: "ri-question-answer-line",
    articleCount: 7,
  },
];